import {
  isFunction
} from '../util'

import packageJson from '../../package.json'

// 将挂载于window.Fusion，用于native回调及全局单例检测
export default {
  // 用于全局单例检测
  __version__: packageJson.version,
  globalInstance: {
    modules: null,
    callbacks: {},
    callbackId: 0
  },

  /**
   * Native 回调 JS
   *
   * @param      {number}  callbackId  回调函数 IDs
   * @param      {array}   args         回调参数
   */
  callbackJS (callbackId, args) {
    const globalInstance = this.globalInstance
    let callback = globalInstance.callbacks[callbackId]
    if (callback && isFunction(callback)) {
      callback.apply(null, args)
    }
  }
}
